module.exports = __webpack_public_path__ + "static/img/童装.9655669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/童装.png
// module id = BTGh
// module chunks = 13